module.exports = __webpack_public_path__ + "static/media/identity.3f66d331.svg";